import { Tag } from "antd";

interface StatusTagProps {
    status: string | any;
}

const StatusTag: React.FC<StatusTagProps> = ({ status }) => {

    const getColor = (statusValue: string | number) => {
        const statusStr = String(statusValue).toLowerCase(); 

        switch (statusStr) {
            case "approved":
            case "active":
            case "paid":
            case "1":
            case "yes":
            case "update":
            case "service":
                return "success";

            case "pending":
            case "created":
            case "draft":
            case "unpaid":
            case "general":
                return "warning";

            case "inactive":
            case "cancelled":
            case "rejected":
            case "deleted":
            case "no":
            case "2":
            case "awaitingapproval":
            case "awaiting approval":
            case "delete":
                return "error";

            default:
                return "default"; // fallback color
        }
    };

    return <Tag color={getColor(status)}>{status}</Tag>;
};

export default StatusTag;
